import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import SecondaryPageLayout from 'components/layouts/Layout/SecondaryPage';
import Docs from 'components/blocks/Docs';

const LicensePage: React.FC = () => {
  const { t } = useTranslation('license');

  return (
    <>
      <Head>
        <meta content={t('page.title')} property='og:title' />
        <meta content={t('page.description')} property='og:description' />
        <meta name='description' content={t('page.description')} />
        <title>{t('page.title')}</title>
      </Head>
      <SecondaryPageLayout>
        <Docs translate='license' />
      </SecondaryPageLayout>
    </>
  );
};

export default LicensePage;
